const STRIPE_LINKS = {
  rhino: 'https://buy.stripe.com/3cI00k0vZh2n3rfdSQ1kA03',
  panda: 'https://buy.stripe.com/14AeVe2E77rNbXLeWU1kA04',
  leo: 'https://buy.stripe.com/8x2cN67Yr27taTHeWU1kA05',
  octomind: 'https://buy.stripe.com/5kQ14oemP7rNf9X0201kA06',
  xillian: 'https://buy.stripe.com/14A9AUemP9zVbXL5mk1kA07',
};

export const checkoutService = {
  async create({ characterKey }) {
    try {
      console.log(`💳 Creating checkout for character: ${characterKey}`);
      
      const checkoutUrl = STRIPE_LINKS[characterKey];

      if (!checkoutUrl) {
        throw new Error(`No Stripe link configured for character: ${characterKey}`);
      }

      // Returns the direct Stripe payment link.
      return {
        success: true,
        checkout_url: checkoutUrl,
        characterKey,
      };
    } catch (error) {
      console.error('❌ Failed to create checkout:', error);
      throw error;
    }
  },

  async handleSuccess(sessionId) {
    try {
      console.log(`✅ Verifying successful checkout: ${sessionId}`);
      // In a real-world application, this would involve a backend call
      // to Stripe's API to verify the session ID is valid and paid.
      // For this client-side simulation, we will assume that if a session ID exists,
      // the payment was successful.
      if (!sessionId) {
        throw new Error('No session ID provided for verification.');
      }
      return { success: true, sessionId, message: 'Purchase completed successfully!' };
    } catch (error) {
      console.error('❌ Failed to process checkout success:', error);
      throw error;
    }
  },
};